__turbopack_context__.v({
  "gallery_container": "styles-module-scss-module__XxJC2a__gallery_container",
  "img1": "styles-module-scss-module__XxJC2a__img1",
  "img2": "styles-module-scss-module__XxJC2a__img2",
  "img3": "styles-module-scss-module__XxJC2a__img3",
  "img3_overlay": "styles-module-scss-module__XxJC2a__img3_overlay",
  "is_desktop": "styles-module-scss-module__XxJC2a__is_desktop",
  "is_mobile": "styles-module-scss-module__XxJC2a__is_mobile",
  "mobile_image_pills": "styles-module-scss-module__XxJC2a__mobile_image_pills",
  "only_one_image": "styles-module-scss-module__XxJC2a__only_one_image",
  "property_status": "styles-module-scss-module__XxJC2a__property_status",
  "property_status_sold": "styles-module-scss-module__XxJC2a__property_status_sold",
  "virtual_tour": "styles-module-scss-module__XxJC2a__virtual_tour",
});
